import styles from './Wallet.module.scss';
import { useGetUser } from '../../../../hooks/useGetUser';
import { CURRENCY } from '../../../../constants';
import { useGetWallet } from '../../../../hooks/useGetWallet';

interface IWalletProps {
    userId: string;
}

export const Wallet = ({ userId }: IWalletProps) => {
    const { walletData, isLoading } = useGetWallet({ userId });

    if (isLoading || !walletData) return null;

    return (
        <div className={styles.container}>
            <div className={styles.title}>Balance</div>
            <div className={styles.walletBlock}>
                <div className={styles.column}>
                    <a className={[styles.row, styles.href].join(' ')}>
                        <div className={styles.balance}>
                            {CURRENCY}
                            {walletData.currentValue}
                        </div>
                    </a>
                    <div className={styles.totalBalance}>Total balance</div>
                </div>
            </div>
        </div>
    );
};
